module.exports = __webpack_public_path__ + "static/media/BlueIcon.0ceaced2.svg";